import { gql, useMutation } from '@apollo/client';

import {
  HandleFavoriteMutation,
  HandleFavoriteMutationVariables,
} from 'src/lib/graphqlTypes/types';

const handleFavoriteMutation = gql<
  HandleFavoriteMutation,
  HandleFavoriteMutationVariables
>`
  mutation HandleFavoriteMutation(
    $serviceId: ID!
    $variantName: String!
    $favorite: Boolean!
  ) {
    __typename
    service(id: $serviceId) {
      id
      variant(name: $variantName) {
        id
        setIsFavoriteOfCurrentUser(favorite: $favorite) {
          id
          isFavoriteOfCurrentUser
        }
      }
    }
  }
`;

interface Args extends HandleFavoriteMutationVariables {
  variantId: string;
}

export const useHandleFavoriteVariant = () => {
  const [baseHandleFavorite, { loading, data, error }] = useMutation(
    handleFavoriteMutation,
  );

  return {
    handleFavorite: ({ serviceId, favorite, variantName, variantId }: Args) => {
      baseHandleFavorite({
        variables: {
          serviceId,
          favorite,
          variantName,
        },
        optimisticResponse: {
          __typename: 'Mutation',
          service: {
            id: serviceId,
            variant: {
              id: variantId,
              setIsFavoriteOfCurrentUser: {
                id: serviceId,
                isFavoriteOfCurrentUser: favorite,
                __typename: 'GraphVariant',
              },
              __typename: 'GraphVariantMutation',
            },
            __typename: 'ServiceMutation',
          },
        },
      });
    },
    loading,
    data,
    error,
  };
};
